export default "__VITE_ASSET__BAJD70gO__"